import apiInstance from '../services/ServiceApi';

const userApi = {
    getUsers: async (page = 0, pageSize = 5, searchTerm = '') => {
        try {
            const response = await apiInstance.get('/manageuser/', {
                params: {
                page: page + 1, // La API usa índice 1-based, por eso se suma 1
                page_size: pageSize,
                search: searchTerm,
                },
            });
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    },
    deleteUser: async (id) => {
        try {
            await apiInstance.delete(`/manageuser/${id}/`);
        } catch (error) {
            console.error("Error al eliminar el usuario:", error);
            throw error;
        }
    },
    
    toggleUserActive: async (id, isActive) => {
        try {
            await apiInstance.patch(`/manageuser/${id}/`, { is_active: isActive });
        } catch (error) {
            console.error("Error al actualizar el usuario:", error);
            throw error;
        }
    },

};

export default userApi;
